import { RgMatchedFace } from '@hakimo-ui/hakimo/types';
import { useEffect, useMemo, useState } from 'react';

export interface FaceWithTime extends RgMatchedFace {
  videoTimeSec: number;
}

export interface FaceDetectionSeek {
  facesWithTime: FaceWithTime[];
  label?: string;
  onClick: () => void;
}

export function useFaceDetectionSeek(
  matchedFaces: RgMatchedFace[] | undefined,
  onSeek: (timeSec: number) => void
): FaceDetectionSeek {
  const facesWithTime = useMemo(
    () =>
      (matchedFaces ?? [])
        .filter(
          (face): face is FaceWithTime => typeof face.videoTimeSec === 'number'
        )
        .sort((a, b) => a.videoTimeSec - b.videoTimeSec),
    [matchedFaces]
  );
  const [index, setIndex] = useState(0);

  useEffect(() => {
    setIndex(0);
  }, [facesWithTime]);

  const onClick = () => {
    if (facesWithTime.length === 0) {
      return;
    }
    const idx = index % facesWithTime.length;
    onSeek(facesWithTime[idx].videoTimeSec);
    setIndex((prev) => (prev + 1) % facesWithTime.length);
  };

  const label =
    facesWithTime.length === 0
      ? undefined
      : facesWithTime.length === 1
      ? 'Face Detection Time'
      : `Face Detection Time (${(index % facesWithTime.length) + 1}/${
          facesWithTime.length
        })`;

  return { facesWithTime, label, onClick };
}
